import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { getNews } from "../Service/Api";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const News = () => {
  const { data: newsData } = useQuery({
    queryKey: ["news"],
    queryFn: getNews,
  });

  const emptyArray = [
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/news.jpg",
      attachments: [],
    },
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/news.jpg",
      attachments: [],
    },
    {
      title: "Stay Tuned For More Updates",
      description: "Stay Tuned For More Updates",
      img: "https://webapi.entab.info/api/image/SJSKBUP/public/Images/news.jpg",
      attachments: [],
    },
  ];

  // ✅ Slick settings (same as before)
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  // ✅ Use fetched data or fallback
  const newsItems = newsData && newsData.length > 0 ? newsData : emptyArray;

  return (
    <>
      <div className="eventbg">
        <Slider {...settings}>
          {newsItems.map((item, index) => (
            <div className="item" key={index}>
              <div className="homeeventbox">
                <div className="homeeventboximg newseventbg">
                  <LazyLoad>
                    {item.image && item.image.length > 0 ? (
                      <img
                        src={`https://webapi.entab.info/api/image/${item.image}`}
                        className="img-fluid"
                        alt={item.title || "News"}
                      />
                    ) : (
                      <img
                        src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/news.jpg"
                        className="img-fluid"
                        alt="News Placeholder"
                      />
                    )}
                  </LazyLoad>

                  <div className="attch">
                    {item.attachments.length > 0 && (
                      <Link
                        to={
                          item.attachments
                            ? `https://webapi.entab.info/api/image/${item.attachments}`
                            : null
                        }
                        target="_blank">
                        <i className="bi bi-paperclip"></i>
                      </Link>
                    )}
                  </div>
                </div>

                <div className="homeeventboxdesc">
                  <div className="homeeventboxtitle">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        <button className="button">
          <Link to="/NewsInner">Read More</Link>
        </button>
      </div>
    </>
  );
};

export default News;
